import { Routes, Route, Navigate } from 'react-router-dom';

// ログインページ
import TeacherLoginPage from './pages/TeacherLoginPage';
import AdminLoginPage from './pages/AdminLoginPage';

// 教師用ページ

// 管理者用ページ
import AdminShiftEntryWindows from './pages/schedule/AdminShiftEntryWindows';
import AdminSchoolHolidaySettings from './pages/schedule/AdminSchoolHolidaySettings';
import AdminTeacherWeeklyShifts from './pages/schedule/AdminTeacherWeeklyShifts';
import AdminStudentUnavailability from './pages/schedule/AdminStudentUnavailability';
import AdminTeacherSchedule from './pages/schedule/AdminTeacherSchedule';
import AdminStudentSchedule from './pages/schedule/AdminStudentSchedule';
import AdminLessonScheduleSnapshots from './pages/schedule/AdminLessonScheduleSnapshots';
import AdminDailySchedule from './pages/schedule/AdminDailySchedule';
import TeacherUnavailabilityInput from './pages/schedule/TeacherUnavailabilityInput';

// 共通リダイレクト
import RedirectExternal from './components/RedirectExternal';
import NotFoundPage from "./pages/NotFoundPage";
import BadRequestPage from "./pages/BadRequestPage";
import ErrorPage from "./pages/ErrorPage";
import LogoutPage from "./pages/LogoutPage";

/**
 * 報告書アプリ専用ルーター
 * ドメインが report アプリのときに利用
 */
export default function AppScheduleRouter({
    isLoggedIn,
    userRole,
    teacherName,
    adminEmail,
    selectedStudents,
    setSelectedStudents,
    isAdminLogin,
    isTeacherLogin,
    getLoginUrl,
    handleLogout,
}) {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    isAdminLogin() ? (
                        <AdminLoginPage onLogin={(email) => handleLogin("admin", email)} />
                    ) : isTeacherLogin() ? (
                        <TeacherLoginPage onLogin={(id, name) => handleLogin("teacher", name)} />
                    ) : !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole === "admin" ? (
                        <Navigate to="/win" replace />
                    ) : userRole === "teacher" ? (
                        <Navigate to="/shift" replace />
                    ) : (
                        <Navigate to="/" replace />
                    )
                }
            />

            {/* 教師専用ルート */}
            <Route
                path="/shift"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "teacher" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <TeacherUnavailabilityInput />
                    )
                }
            />
            <Route
                path="/schedule"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "teacher" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminTeacherSchedule userRole={userRole} currentTeacherId={sessionStorage.getItem("teacherid")} onLogout={handleLogout} />
                    )
                }
            />

            {/* 管理者専用ルート */}
            <Route
                path="/holiday"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminSchoolHolidaySettings onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/win"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminShiftEntryWindows onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/regular"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminTeacherWeeklyShifts onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/su"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminStudentUnavailability onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/teacher"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminTeacherSchedule userRole={userRole} onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/student"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminStudentSchedule onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/snapshot"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminLessonScheduleSnapshots onLogout={handleLogout} />
                    )
                }
            />
            <Route
                path="/diary"
                element={
                    !isLoggedIn ? (
                        <RedirectExternal url={getLoginUrl()} />
                    ) : userRole !== "admin" ? (
                        <Navigate to={`/${userRole}`} replace />
                    ) : (
                        <AdminDailySchedule onLogout={handleLogout} />
                    )
                }
            />
            <Route path="/error/400" element={<BadRequestPage />} />
            <Route path="/error/404" element={<NotFoundPage />} />
            <Route path="/error/500" element={<ErrorPage />} />
            <Route path="/logout" element={<LogoutPage onLogout={handleLogout} />} />
            <Route path="*" element={<Navigate to="/error/404" replace />} />
        </Routes>
    );
}
